<template>
  <div class="page-content recurring payments">
    <img class="recurring-illustration" src="@/assets/images/illustration-10.png" />
    <div class="page-title">
      <span>{{ $lang.messages.payments.toUpperCase() }} / </span>
      <span class="text">{{ $lang.messages.recurring.toUpperCase() }}</span>
    </div>
    <div class="page-wrapper-recurring-payments">
      <div class="card">
        <div class="card-header">
          <h4>{{ $lang.messages.yourRecurringPayment }}</h4>
          <span class="box-name-info" @click="tooltip = true" :class="{ 'blue-box-info': tooltip}"></span>
          <f-p-tooltip
            v-if="tooltip"
            v-click-outside="hideTooltip"
            :hideTooltipInside="hideTooltip"
            :tooltipTitle="$lang.messages.tp_paymentsToPayTitle"
            :tooltipContent="$lang.messages.tp_paymentsToPayText">
          </f-p-tooltip>
        </div>
        <div
          class="card-content"
        >
          <div class="skeleton-screen" v-show="loading" v-for="(i) of skeletonArray">
            <div class="skeleton-card">
              <div class="skeleton-content">
                <div class="skeleton-heading">
                  <div></div>
                  <div></div>
                </div>
                <div class="skeleton-amount"></div>
                <div class="skeleton-attachments"></div>
              </div>
            </div>
          </div>
          <div
            v-for="(i, indexRecData) of recurringData"
            :key="indexRecData"
            v-show="!loading"
          >
            <router-link :to="{ name: computedRoute(i.expenseType), params: {id: i.guid}}">
              <div>
                <div class="content-header">
                  <p>{{i.scheduled}}</p>
                </div>
                <div class="content-title">
                  <p>{{i.summary}}</p>
                </div>
                <div class="content-data">
                  <p>
                    <currency-sign :currency="i.currency"></currency-sign>
                    {{ currencyFormat(i.amount) }}
                  </p>
                </div>
                <div class="content-attachments">
                  <div class="note">
                    <img
                      v-if=" !i.note"
                      src="@/assets/images/payments/note_ico_disabled.png"
                    />
                    <img
                      v-if="i.note"
                      src="@/assets/images/payments/note_ico.png"
                    />
                    <div v-show="i.note">
                      {{i.note}}
                    </div>
                  </div>
                  <div
                    class="group"
                    v-show="i.attachments.length > 0">
                    <div
                      v-for="(img, indexAttImg) of computedAttachment(i.attachments)"
                      :key="indexAttImg"
                      v-if="indexAttImg < 2"
                    >
                      <f-p-documents :type="img.toLowerCase()"></f-p-documents>
                    </div>
                    <div
                      v-if="(i.attachments.length - Math.min(computedAttachment(i.attachments).length, 2)) > 0"
                      class="document-count"
                    >
                      +{{ i.attachments.length - Math.min(computedAttachment(i.attachments).length, 2) }}
                    </div>
                  </div>
                </div>
                <div
                  v-if="i.nextScheduledDate !== null"
                  class="next-payment"
                >
                  <p><b>{{ $lang.messages.nextPayment }}</b> • {{ dateFormat(i.nextScheduledDate) }}</p>
                </div>
              </div>
            </router-link>
          </div>
          <div v-if="recurringData.length === 0 && loaded" class="no-illustration-label">
            <img src="@/assets/images/payments/empty_table_illustration.png">
            <p><b>{{ $lang.messages.nothingHere }}</b></p>
            <p>{{ $lang.messages.setUpFirst }}</p>
            <p>{{ $lang.messages.dontWorrySimpleSteps }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapActions } from "vuex";
  import { GET_ALL_RECURRING_EXPENSES } from "@/store/action.types";
  import { currencyFormat} from "@/mixins/currencyFormat";
  import { dateFormat } from '@/mixins/dateFormat';
  import CurrencySign from "@/components/common/CurrencySign";
  import FPDocuments from '@/components/common/FPDocuments';
  import vClickOutside from 'v-click-outside';
  import STATUS_CODES from "@/common/statusCodes";

  export default {
    name: "Recurring",
    components: {
      CurrencySign,
      'f-p-tooltip': () => import('@/components/common/FPTooltip'),
      'f-p-documents': FPDocuments
    },
    directives: {
      clickOutside: vClickOutside.directive
    },
    mixins: [
      currencyFormat,
      dateFormat
    ],
    data() {
      return {
        currency: localStorage.getItem('currency') ? localStorage.getItem('currency').substr(1, localStorage.getItem('currency').length - 2) : '',
        recurringData: [],
        loaded: false,
        tooltip: false,
        loading: true,
        skeletonArray: [{}, {}],
      }
    },
    mounted() {
      this.getRecurringExpenses();
    },
    methods: {
      ...mapActions({
        getAllRecurringExpensesAction: GET_ALL_RECURRING_EXPENSES
      }),
      getRecurringExpenses() {
        this.loading = true;
        this.getAllRecurringExpensesAction()
        .then(response => {
          this.recurringData = response.data.data;
          this.loaded = true;
          this.loading = false;
        })
        .catch(error => {
          if (error.response.status !== 406 && error.response.data.status.code !== STATUS_CODES.FP_405 && error.response.status !== 401 && error.response.status !== 402) {
            this.$snotify.error(this.$lang.messages.sn_genericError, 'ERROR');
          }
        });
      },
      computedAttachment(attachment) {
        let returnAttachment = [];
        for (let a of attachment) {
          if (returnAttachment.indexOf(a.extension) === -1) {
            returnAttachment.push(a.extension);
          }
        }
        return returnAttachment;
      },
      computedRoute(expenseType) {
        return (expenseType === this.$ALIMONY_EXPENSE_TYPE ?
          'SpousalMaintenanceRecurringExpensesDetails' : expenseType === this.$CHILD_EXPENSE_TYPE ?
          'ChildMaintenanceRecurringExpensesDetails' : 'SharedExpensesRecurringExpensesDetails');
      },
      hideTooltip(e) {
        e.stopPropagation()
        this.tooltip = false;
      },
    }
  }
</script>

<style scoped>
  .content-data p {
    text-align: right;
    width: 100%;
  }
</style>
